<template>
    <div class="custom-product-carousel-card">
        <div class="image-wrapper">
            <ThLink
                v-if="data.link"
                v-bind="buttonBind"
            >
                <CmsImage
                    :data="data.image"
                    class="image"
                    :sizes="sizes"
                />
            </ThLink>

            <CmsImage
                v-else
                :data="data.image"
                class="image"
                :sizes="sizes"
            />
        </div>

        <div class="text-wrapper">
            <h3 class="title">
                <ThLink
                    v-if="data.link"
                    v-bind="buttonBind"
                >
                    {{ data.title }}
                </ThLink>

                <span v-else>
                    {{ data.title }}
                </span>
            </h3>

            <div class="text">
                <ThLink
                    v-if="data.link"
                    v-bind="buttonBind"
                >
                    {{ data.description }}
                </ThLink>

                <span v-else>
                    {{ data.description }}
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'
import { useCmsLink } from '@/components/cms'
import type { ComponentCustomProductCarouselFragment } from '@/graphql/api'

import ThLink from '@/components/ui/buttons/ThLink.vue'
import CmsImage from '@/components/cms/CmsImage.vue'
import type { ImageSizes } from '@/components/getImageProps.ts'

const props = defineProps<{
    data: ComponentCustomProductCarouselFragment['products'][number]
    sizes?: ImageSizes
}>()

const buttonBind = useCmsLink(toRef(() => props.data.link))
</script>

<style lang="scss" scoped>
.custom-product-carousel-card {
    position: relative;
    // width: 100%;
    height: 390px;
    border: 1px solid $grey-300;
    background: $white;
    z-index: 2;

    @include min-width(1024) {
        margin: 0;
        height: 280px;
        transition: $default-transition;
        overflow-y: hidden;
    }

    @include hover() {
        @include min-width(1024) {
            height: 390px;
            transition: height 0.3s ease-in-out;
        }
    }

    .image-wrapper {
        height: 280px;
        display: flex;
        align-items: center;

        .image {
            width: 100%;
        }
    }

    .text-wrapper {
        height: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        @include min-width(1024) {
            text-align: center;
        }

        .title {
            width: 100%;
            display: block;
            text-align: left;
            font-family: $parcel-font-stack;
            letter-spacing: 0.01em;
            font-size: 1.5rem;
            line-height: 1.875rem;
            margin: 0 0 15px;
            padding: 0 20px;

            @include min-width(1024) {
                text-align: center;
            }
        }

        .text {
            padding: 0 20px;
        }
    }
}
</style>
